import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Accordion } from 'formlabs-web-components/Media';

import './FilterSidebar.module.css';
import NoResults from './NoResults';

const FilterSidebar = ({
  children,
  content,
  contentLength,
  activeFilterCount,
  resetFilterAction
}) => {
  const { t } = useTranslation();
  const [overlayShowing, setOverlayShowing] = useState(false);

  return (
    <>
      <button
        styleName="open-filters"
        onClick={() => setOverlayShowing(!overlayShowing)}
      >
        <i className="fl-filter" />{' '}
        <span style={{ marginLeft: '1rem' }}>{t('Filters')}</span>
      </button>

      <div styleName="container">
        <div styleName="sidebar">
          <div styleName="headline">
            <span styleName="filter-label">{t('Filter')}</span>
            <span>|</span>
            <button styleName="reset" onClick={resetFilterAction}>
              {`${t('Reset')} (${activeFilterCount})`}
            </button>
          </div>
          <div
            styleName={classNames({
              'overlay-open': overlayShowing,
              'overlay-closed': !overlayShowing
            })}
          >
            <Accordion type="filter-list">{children}</Accordion>
            <div styleName="open-filters bottom">
              <span>
                <button styleName="reset" onClick={() => resetFilterAction()}>
                  {t('Reset')}
                </button>
                <button
                  styleName="doneBtn"
                  onClick={() => setOverlayShowing(false)}
                >
                  {t('Done')}
                </button>
              </span>
            </div>
          </div>
        </div>

        <div styleName="list">
          {contentLength ? (
            content
          ) : (
            <NoResults resetFilterAction={resetFilterAction} />
          )}
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;
